import { Box, Typography, Card } from "@mui/material";
import { styled } from "@mui/system";
import { FC } from "react";

const ChatBubbleWrapper = styled(Box)(({ theme, position }) => ({
    display: "flex",
    //@ts-ignore
    justifyContent: position === "right" ? "flex-end" : "flex-start",
    marginBottom: theme.spacing(1),
}));

interface ChatBubbleProps {
    position: "left" | "right";
  }

const ChatBubbleStyled = styled(Card)<ChatBubbleProps>(({ theme, 
    position }) => ({
    padding: theme.spacing(1.5),
    borderRadius: "12px",
    marginTop:10,
    marginLeft:position !== "right" ?6: 0,
    marginRight:position === "right" ?10: 0,
    maxWidth: "80%",
    wordBreak: "break-word",
    backgroundColor: position !== "right" ? "#fff" : theme.palette.grey[100] ,
    color: position === "right" ? "#fff" : "#000",
    boxShadow: "2px 2px 10px rgba(0,0,0,0.1)",
}));

const ChatBubble: FC<any> = ({ position, children }) => {
    return (
        <ChatBubbleWrapper position={position}>
            <ChatBubbleStyled position={position}>
                <Typography variant="body2">{children}</Typography>
            </ChatBubbleStyled>
        </ChatBubbleWrapper>
    );
};

export default ChatBubble;
